import React from 'react';

// WU-F (RJ, staging pass 2026-08-09): "give the user a simple
// acknowledgement when they load things."
//
// Before this, an upload produced a row in a list and nothing else. The one
// moment the user has just done work was the one moment the product said
// nothing back.
//
// There are TWO upload paths — the Evidence tab's per-Outcome drop zone and
// the Delivery status card's promoted "Add <file>" target (WU-C). Both live
// here, because a receipt that exists on one of them leaves the other in
// exactly the state RJ reported (QA finding B4).
//
// The count is stated only when part of the batch failed. A bare "2 files
// added" when three were dropped would hide a failure inside a success.

export function receiptFor(addedFilenames, totalAttempted, outcomeName) {
  if (!Array.isArray(addedFilenames) || addedFilenames.length === 0) return null;
  return { files: addedFilenames, total: totalAttempted, outcomeName };
}

export function receiptHeadline({ files, total, outcomeName }) {
  const n = files.length;
  const noun = `file${n === 1 ? '' : 's'}`;
  return n === total
    ? `${n} ${noun} added to ${outcomeName}`
    : `${n} of ${total} files added to ${outcomeName}`;
}

export default function UploadReceipt({ receipt, onDismiss, compact = false }) {
  if (!receipt) return null;
  return (
    <div
      className={`rounded-lg border border-emerald-200 bg-emerald-50 ${compact ? 'mt-1.5 px-3 py-2' : 'px-4 py-3 mb-4'}`}
      data-testid="upload-receipt"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <div className={`font-bold text-emerald-800 ${compact ? 'text-[12px]' : 'text-[13px]'}`}>
            {receiptHeadline(receipt)}
          </div>
          <ul className="mt-1 space-y-0.5">
            {receipt.files.map((name, i) => (
              // Keyed by position: a drag-drop batch can carry two files with
              // the same name from different folders.
              <li key={`${name}-${i}`} className={`text-gray-700 font-medium ${compact ? 'text-[11.5px]' : 'text-[12.5px]'}`}>
                {name}
              </li>
            ))}
          </ul>
        </div>
        {onDismiss && (
          <button type="button" onClick={onDismiss} className="text-[11.5px] font-semibold text-emerald-800">
            Dismiss
          </button>
        )}
      </div>
    </div>
  );
}
